<template>
  <div>
    <a-page-header title="批量建班" @back="() => $router.go(-1)">
    </a-page-header>
    <div class="table-top">
      <!-- 选择学期 -->
      <div class="semester">
        <span class="required">*</span>
        <span class="text">选择学期</span>
        <a-select style="width: 286px" placeholder="请选择" @change="changeTerm">
          <a-select-option v-for="item in termList" :key="item.id" :value="item.id">
            {{ item.termName }}
          </a-select-option>
        </a-select>
        <span class="tips">不支持已结束的学期</span>
      </div>
      <!-- 选择文件 -->
      <div class="file">
        <span class="required">*</span>
        <span class="text">选择文件</span>
        <!-- 导入班级 -->
        <div class="import-excel">
          <!-- 上传文件解析前显示 -->
          <div v-if="!fileLoding">
            <a-button class="import-btn">
              <img src="/icon/add.png" />
              <input type="file" @change="chooseFile" accept=".csv, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
            </a-button>
          </div>
          <!-- 上传文件解析后显示 -->
          <div v-if="fileLoding">
            <span class="file-name">{{ fileName }}</span>
            <a-button>重新导入
              <input type="file" @change="chooseFile" accept=".csv, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
            </a-button>
          </div>
        </div>
        <!-- 导入模板 -->
        <a
          class="template"
          href="https://static.khsdb.com/place/template/班级导入样表20250207.xlsx"
          download="批量建班模板"
          @click="importTemplate()"
          >导入模板</a
        >
        <div class="tips">导入班级每次不超过200个</div>
      </div>
      <!-- 导入预览 -->
      <a-button type="primary" class="preview" @click="preview()">导入预览</a-button>
    </div>
    <!-- 表格部分 -->
    <div class="table" v-if="classList.length > 0">
      <a-table :columns="columns" :data-source="classList" bordered :pagination="false">
        <!-- 开班时间 -->
        <span slot="textStartClassDate" slot-scope="text">
          <span>{{ text ? text : '' }}</span>
        </span>
        <span slot="flexibleSchedule" slot-scope="text">
          <span>{{
            text == '0' ? '固定排课' : text == '1' ? '灵活排课' : ''
          }}</span>
        </span>
        <!-- 开始报名 -->
        <span slot="textApplyStartTime" slot-scope="text">
          <span>{{ text ? text : '' }}</span>
        </span>
        <!-- 结束报名 -->
        <span slot="textApplyEndTime" slot-scope="text">
          <span>{{ text ? text : '' }}</span>
        </span>
        <!-- 上课计划 -->
        <span slot="textTeachingPlan" slot-scope="text" v-if="text">
          <span v-for="(plan, index) in JSON.parse(text)" :key="index">{{ plan.classWeeks }} {{ plan.classTime }},</span>
        </span>

        <!-- 状态 -->
        <span slot="status" slot-scope="text">
          <span :class="{ active: text == 'false' }">{{
            text == '' ? '校验中' : text == 'true' ? '可导入' : '存在错误'
          }}</span>
        </span>
        <!-- 操作 -->
        <span slot="action" slot-scope="text, record">
          <span v-if="record.status == 'true'">无</span>
          <span class="error" v-else @click="errInfo(text)">查看错误</span>
        </span>
      </a-table>
      <div class="confirm-btn">
        <a-button type="primary" :disabled="confirmBtn || loading" @click="confirm()">确认建班</a-button>
      </div>
    </div>
    <!-- 查看错误框 -->
    <a-modal v-model="visibleErr" title="错误信息" width="358px" :footer="null">
      <p v-for="(item, index) in errorMsgList" :key="index">
        {{ index + 1 }}. {{ item }}
      </p>
      <div class="confirm-err">
        <a-button type="primary" @click="confirmErr()">我知道了</a-button>
      </div>
    </a-modal>
    <!-- 确认建班/重新导入框 -->
    <a-modal v-model="visibleWarn" width="358px" :closable="false" :footer="null">
      <div class="warning-title">
        <img src="/icon/warning.png" />
        <span v-if="isConfirm">确认建班</span>
        <span v-else>确认重新导入预览</span>
      </div>
      <div class="warning-content" v-if="isConfirm">
        确认创建这{{ classList.length }}个班级?
      </div>
      <div class="warning-content" v-else>未保存的数据将丢失，是否确认</div>
      <div class="confirm-warn">
        <a-button class="mr8" @click="cancelWarn()">取消</a-button>
        <a-button type="primary" v-if="isConfirm" @click="confirmWarn()">确认</a-button>
        <a-button type="primary" v-else @click="importWarn()">确认</a-button>
      </div>
    </a-modal>
    <!-- 建班成功/建班失败框 -->
    <a-modal :afterClose="closeModal" v-model="visibleTips" width="358px" :closable="false" :footer="null">
      <!-- 加载中 -->
      <div v-if="loading" class="spin"><a-spin tip="正在建班中,请稍等" /></div>
      <div v-else>
        <!-- 建班失败 -->
        <div class="tips-title" v-if="errorClass">
          <img src="/icon/fail.png" />
          <div class="title">建班失败</div>
          <div>失败原因：{{ errText }}</div>
          <a-button type="primary" class="btn" @click="errorBtn">返回</a-button>
        </div>
        <!-- 建班成功 -->
        <div class="tips-title" v-if="successClass">
          <img src="/icon/success.png" />
          <div class="title">建班成功</div>
          <div>已成功创建{{ classList.length }}个班级</div>
          <a-button type="primary" class="btn" @click="successBtn">确认</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import education from '../../api/education'
import moment from 'moment'
const columns = [
  {
    title: '序号',
    dataIndex: 'ordinal',
    key: 'ordinal',
    align: 'center',
  },
  {
    title: '排课类型',
    dataIndex: 'flexibleSchedule',
    key: 'flexibleSchedule',
    scopedSlots: { customRender: 'flexibleSchedule' },
    align: 'center',
  },
  {
    title: '开班时间',
    dataIndex: 'textStartClassDate',
    key: 'textStartClassDate',
    scopedSlots: { customRender: 'textStartClassDate' },
    align: 'center',
  },
  {
    title: '开始报名',
    dataIndex: 'textApplyStartTime',
    key: 'textApplyStartTime',
    scopedSlots: { customRender: 'textApplyStartTime' },
    align: 'center',
  },
  {
    title: '结束报名',
    dataIndex: 'textApplyEndTime',
    key: 'textApplyEndTime',
    scopedSlots: { customRender: 'textApplyEndTime' },
    align: 'center',
  },
  {
    title: '课程类型',
    dataIndex: 'courseType',
    key: 'courseType',
    align: 'center',
  },
  {
    title: '结班日期',
    dataIndex: 'endClassDate',
    key: 'endClassDate',
    scopedSlots: { customRender: 'endClassDate' },
    align: 'center',
  },
  {
    title: '课程名称',
    key: 'courseName',
    dataIndex: 'courseName',
    align: 'center',
  },
  {
    title: '适用年级',
    key: 'textGradeScope;',
    dataIndex: 'textGradeScope',
    align: 'center',
  },
  {
    title: '班级名称',
    key: 'className',
    dataIndex: 'className',
    align: 'center',
  },
  {
    title: '人数下限',
    key: 'textLowerLimit',
    dataIndex: 'textLowerLimit',
    align: 'center',
  },
  {
    title: '人数上限',
    key: 'textUpperLimit',
    dataIndex: 'textUpperLimit',
    align: 'center',
  },
  {
    title: '付费模式',
    key: 'textPaymentMode',
    dataIndex: 'textPaymentMode',
    align: 'center',
  },
  {
    title: '上课周期',
    key: 'textEveryOtherWeek',
    dataIndex: 'textEveryOtherWeek',
    align: 'center',
  },
  {
    title: '上课计划',
    key: 'textTeachingPlan',
    dataIndex: 'textTeachingPlan',
    scopedSlots: { customRender: 'textTeachingPlan' },
    align: 'center',
  },
  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    align: 'center',
  },
]

export default {
  name: 'classBatch',
  data() {
    return {
      columns,
      classList: [],
      beforePreview: [], // 导入预览前的班级列表
      termList: [], // 学期列表
      termId: '', // 选择的学期id
      selectFile: '', // 选择的文件file
      fileLoding: false, // 文件是否解析完
      fileName: '', // 上传的文件名
      isConfirm: true, // 是否选择确认建班
      visibleErr: false, // 查看错误模态框
      visibleWarn: false, // 确认建班/重新导入模态框
      batchNumber: '', // 确认建班批次参数
      errorMsgList: [], // 错误信息列表
      checkConfirm: false, // 校验是否无错误信息
      visibleTips: false, // 创建成功/失败模态框
      successClass: false, // 创建成功
      errorClass: false, // 创建失败
      errText: '', // 创建失败原因
      importErr: '', // 选择文件失败原因
      confirmBtn: false, // 是否有错误，true-禁用确认建班 false-启用确认建班
      loading: false,
    }
  },
  methods: {
    moment,
    // 获取学期列表
    getTermList() {
      education.getClassTermList().then((res) => {
        this.termList = res.data
        console.log('获取学期列表--------', res)
      })
    },
    // 选择学期
    changeTerm(value) {
      this.termId = value
      // this.selectFile = ''
      // this.fileName = ''
      // this.fileLoding = false
      this.classList = []
      console.log(`选择的学期id ${this.termId}`)
    },
    // 如果没选择学期提示
    tipsTerm() {
      this.$message.error('请先选择学期')
    },
    // 导入模板
    importTemplate() {
      console.log('导入模板')
    },
    // 蒙层关闭事件
    closeModal(e) {
      console.log('关闭了吗', e)
      if (this.successClass == true) {
        this.successClass = false
      } else if (this.errorClass == true) {
        this.errorClass = false
      }
    },
    ///选择文件
    chooseFile(e) {
      this.classList = []
      this.selectFile = e.target.files[0]
      this.fileName = e.target.files[0].name
      this.fileLoding = true
      e.target.value = ''
      console.log('选择文件进来了吗')
      this.confirmBtn = false
    },

    // 导入预览
    preview() {
      if (!this.termId) {
        this.$message.error('请选择学期')
        return
      }
      if (!this.selectFile) {
        this.$message.error('请选择文件')
        return
      }
      if (this.classList.length !== 0) {
        this.isConfirm = false
        this.visibleWarn = true
        return
      }
      console.log('this.selectFile------', this.selectFile)
      console.log('this.termId------', this.termId)
      // 上传文件
      education
        .checkFileInfo({ fileName: this.selectFile, termId: this.termId })
        .then((res) => {
          this.importErr = ''
          this.beforePreview = res.data
          this.batchNumber = res.data[0].batchNumber
          console.log('选择文件--------', this.beforePreview)
          // 导入预览
          // this.beforePreview.forEach((v, i) => {

          // })
          this.recursion(0)
        })
        .catch((err) => {
          // this.importErr = err.msg
          console.log('错误信息列表', err)
          this.$message.destroy()
          this.errorMsgList = []
          this.errorMsgList.push(err.msg)
          this.visibleErr = true
        })
    },
    recursion(i) {
      education
        .importPreview({ importId: this.beforePreview[i].id })
        .then((res) => {
          if (res.data) {
            this.beforePreview[i].status = res.data.results
            if (res.data.results == 'false') {
              this.beforePreview[i].action = JSON.parse(res.data.errorMsg)
              this.confirmBtn = true
            }
            console.log(this.beforePreview[i], 'dasdaweqsadas')
            this.beforePreview[i].textStartClassDate = moment(this.beforePreview[i].textStartClassDate).format('YYYY-MM-DD')
            this.beforePreview[i].endClassDate = this.beforePreview[i].endClassDate ? moment(this.beforePreview[i].endClassDate).format('YYYY-MM-DD') : ''
            this.classList.push(this.beforePreview[i])
            this.classList.sort((a, b) => {
              return a.ordinal - b.ordinal
            })
            console.log('导入预览-------', this.classList)
          }
          if (i < this.beforePreview.length - 1) {
            console.log('i', i)
            this.recursion(++i)
          }
        })
    },

    // 查看错误
    errInfo(errMsg) {
      this.errorMsgList = errMsg
      this.visibleErr = true
    },
    // 关闭查看错误
    confirmErr() {
      this.visibleErr = false
    },
    // 确认建班
    confirm() {
      this.visibleWarn = true
      this.isConfirm = true
      console.log('确认建班')
    },
    // 确认建班/重新导入框取消按钮
    cancelWarn() {
      this.visibleWarn = false
    },
    // 确认建班确定按钮
    confirmWarn() {
      this.loading = true
      this.visibleWarn = false
      this.visibleTips = true
      education
        .confirmImport({ batchNumber: this.batchNumber })
        .then((res) => {
          console.log('创建班级成功', res)
          this.successClass = true
          this.loading = false
        })
        .catch((err) => {
          console.log('创建班级失败', err)
          this.$message.destroy()
          this.errorClass = true
          this.errText = err.msg
          this.loading = false
        })
    },
    // 建班失败返回按钮
    errorBtn() {
      this.visibleTips = false
      this.errorClass = false
    },
    // 建班成功确定按钮
    successBtn() {
      this.visibleTips = false
      this.successClass = false

      this.$router.push({
        name: 'classList',
      })
    },
    // 重新导入确定按钮
    importWarn() {
      this.visibleWarn = false
      this.classList = []
      this.preview()
    },
  },
  created() {
    this.getTermList()
  },
}
</script>

<style lang="scss" scoped>
.ant-page-header {
  padding: 0;
}

/deep/.ant-modal-header {
  text-align: center;
}

.mr8 {
  margin-right: 8px;
}

.table-top {
  margin-top: 13px;
  border-top: 1px solid rgba(0, 0, 0, 0.6);
  padding-top: 29px;
  padding-bottom: 16px;

  .required {
    color: red;
  }

  .tips {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #bfbfbf;
    margin-left: 12px;
  }

  //  选择学期 选择文件
  .semester,
  .file {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;

    .text {
      color: #333;
      margin-right: 12px;
    }

    .import-excel {
      display: inline-block;
      position: relative;
      display: inline-block;

      .import-btn {
        width: 106px;
        height: 32px;
        cursor: none;

        img {
          width: 16px;
          height: 16px;
        }
      }

      input {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 110px;
        height: 32px;
        z-index: 999;
        opacity: 0;
      }
    }
  }

  // 选择文件
  .file {
    margin-top: 28px;

    .file-name {
      margin-right: 12px;
    }

    .template {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #1890ff;
      margin-left: 12px;
      text-decoration: underline;
    }
  }

  // 导入预览
  .preview {
    margin-top: 27px;
  }
}

.active {
  color: #ff0000;
  cursor: pointer;
}

.error {
  color: #1890ff;
  cursor: pointer;
}

// 表格部分
.table {
  .confirm-btn {
    text-align: center;
    margin-top: 32px;
  }
}

// 查看错误
.confirm-err {
  text-align: center;
  margin-top: 39px;
}

// 确认建班/重新导入
.confirm-warn {
  text-align: center;
  margin-top: 48px;
}

.warning-title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);

  img {
    width: 20px;
    height: 20px;
    margin-right: 4px;
  }
}

.warning-content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.65);
  margin-top: 12px;
  text-align: center;
}

// 建班成功/建班失败
.tips-title {
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.85);

  img {
    width: 60px;
    height: 60px;
    margin-bottom: 8px;
  }

  .title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 6px;
  }

  .btn {
    margin-top: 35px;
  }
}

.spin {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}
</style>
